// extracted by mini-css-extract-plugin
export default {"modal":"LqYeYXQyphfcQZDsq12X","modalOverlay":"pY2zoLDw_ktihUE7D2cE","modalContent":"u7lo_ysZuVeTbVA6r26n","footer":"r2EqoqplrGUaGmaAQk_9","footerContent":"bWErOfvK4l3tUuwYMNTU"};